<h1>THIS PATH HAS TO BE IMPLEMENTED!</h1>
<h2>{{router.routerState.snapshot.url}}</h2>
<mat-divider></mat-divider>

<h3>Available paths</h3>

<p *ngFor="let p of config">
  <a [routerLink]="p">{{p}}</a>
</p>